import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faGraduationCap, faUsers } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career & Education History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Feb 2026 - Present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Binance Angel</h3>
            <h4 className="vertical-timeline-element-subtitle">Binance</h4>
            <p>
              Community management, hosting local/online events, educating the community on blockchain, and supporting Binance ecosystem initiatives.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jan 2026 - Mar 2026"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faUsers} />}
          >
            <h3 className="vertical-timeline-element-title">Mentor</h3>
            <h4 className="vertical-timeline-element-subtitle">Social Winter of Code (SWOC)</h4>
            <p>
              Mentored students in open-source software development, conducted code reviews, and guided contributors.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jul 2025 - Feb 2026"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Campus Ambassador</h3>
            <h4 className="vertical-timeline-element-subtitle">E-Cell, IIT Bombay & Unstop</h4>
            <p>
              Represented organizations, fostered engagement in entrepreneurial challenges, hackathons, and technology events on campus.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="May 2025 - Sep 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Manager of Artificial Intelligence</h3>
            <h4 className="vertical-timeline-element-subtitle">BREYUS</h4>
            <p>
              Architected machine learning solutions, managed AI development pipelines, and led deep learning integration strategies.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jan 2025 - Mar 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faUsers} />}
          >
            <h3 className="vertical-timeline-element-title">Education Mentor</h3>
            <h4 className="vertical-timeline-element-subtitle">Social Winter of Code (SWOC)</h4>
            <p>
              Taught foundational tech stacks and mentored newcomers navigating the open-source landscape.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            date="Aug 2024 - May 2027 (Expected)"
            iconStyle={{ background: '#e38b06', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faGraduationCap} />}
          >
            <h3 className="vertical-timeline-element-title">B.Tech in Computer Science (AI & ML)</h3>
            <h4 className="vertical-timeline-element-subtitle">Reva University, Bangalore</h4>
            <p>
              Specialization in Artificial Intelligence and Machine Learning.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            date="Aug 2021 - Aug 2024"
            iconStyle={{ background: '#e38b06', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faGraduationCap} />}
          >
            <h3 className="vertical-timeline-element-title">Diploma in Computer Science</h3>
            <h4 className="vertical-timeline-element-subtitle">NMIT Polytechnic</h4>
            <p>
              Foundational courses in Software Engineering, DSA, and Web Tech.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jul 2023 - Dec 2023"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">AI/ML Engineering Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">Karunadu Technologies Pvt Ltd</h4>
            <p style={{ margin: '5px 0', fontSize: '0.95em' }}>
              • Designed and optimized ML/NLP model pipelines reducing inference latency by 18%; deployed models via Docker + REST APIs cutting integration time by 30%.
            </p>
            <p style={{ margin: '5px 0', fontSize: '0.95em' }}>
              • Built scalable data processing infrastructure in collaboration with senior engineers, serving diverse production workloads across client applications.
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;